import { requestJson } from "../api/apiClient";

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, String(value));
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchVehicleDealFinderOverview(params = {}) {
  return requestJson(`/api/mobility/vehicle-deals/overview${buildQuery(params)}`);
}

export async function fetchVehicleDealSection(sectionKey, params = {}) {
  return requestJson(
    `/api/mobility/vehicle-deals/sections/${encodeURIComponent(sectionKey)}${buildQuery(params)}`
  );
}

export async function fetchVehicleDealFinderDiagnostics() {
  return requestJson("/api/admin/mobility/vehicle-deal-finder/diagnostics");
}
